import { useEffect, useState, useRef, useMemo } from 'react';
import { useAuth } from '../Auth';
import debounce from 'lodash.debounce';
import API from '../../API';

export const useNotes = (qrId) => {
    const { dataDispatch, qr_data } = useAuth();
    const [notes, setNotes] = useState('');
    const { updateQR } = API;
    
    const isReadyRef = useRef(false);

    useEffect(() => {
        isReadyRef.current = false;
        // Potentially clear notes immediately so the user doesn't see old data (setNotes(''))
    }, [qrId]);

    useEffect(() => {
        const isCorrectData = qr_data?.id === qrId;
        
        if (isCorrectData && !isReadyRef.current) {
            setNotes(qr_data?.data?.notes || '');
            isReadyRef.current = true;
        }
    }, [qr_data, qrId]);

    const debouncedUpdate = useMemo(() => 
        debounce(async (id, newNotes) => {
            try {
                await updateQR(id, { 
                    qrDataType: "", 
                    files: [], 
                    data: { notes: newNotes }
                });
            } catch (err) {
                console.error("Failed to update notes:", err);
            }
        }, 1000), 
    [updateQR]);

    useEffect(() => {
        const isCorrectData = qr_data?.id === qrId;
        const hasChanged = notes !== (qr_data?.data?.notes || '');

        if (isReadyRef.current && isCorrectData && hasChanged) {
            dataDispatch({ type: 'notes', data: notes });
            debouncedUpdate(qrId, notes);
        }

        return () => debouncedUpdate.cancel();
    }, [notes, qrId, dataDispatch, debouncedUpdate]);

    return { notes, setNotes, isLoading: !isReadyRef.current };
};